"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* tslint:disable */
var React = require("react");
var Utilities_1 = require("../../../Utilities");
/* tslint:enable */
var BasePicker_1 = require("../BasePicker");
var TagItem_1 = require("./TagItem");
var stylesImport = require("./TagItem.scss");
var styles = stylesImport;
var TagPicker = (function (_super) {
    tslib_1.__extends(TagPicker, _super);
    function TagPicker() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TagPicker.defaultProps = {
        onRenderItem: function (props) { return React.createElement(TagItem_1.TagItem, tslib_1.__assign({}, props), props.item.name); },
        onRenderSuggestionsItem: function (props) { return React.createElement("div", { className: Utilities_1.css('ms-TagItem-TextOverflow', styles.tagItemTextOverflow) },
            " ",
            props.name,
            " "); }
    };
    return TagPicker;
}(BasePicker_1.BasePicker));
exports.TagPicker = TagPicker;
//# sourceMappingURL=TagPicker.js.map


//////////////////
// WEBPACK FOOTER
// ../~/office-ui-fabric-react/lib/components/pickers/TagPicker/TagPicker.js
// module id = ../node_modules/office-ui-fabric-react/lib/components/pickers/TagPicker/TagPicker.js
// module chunks = 1